// removed by extract-text-webpack-plugin
module.exports = {"button-panel":"style__button-panel___1dDSW","action-button":"style__action-button___2rMEe","map":"style__map___1fONG","address-form":"style__address-form___2nDh_","new-venue-panel":"style__new-venue-panel___8Vyab","locate-marker-button":"style__locate-marker-button___3zZc9"};


//////////////////
// WEBPACK FOOTER
// ./components/VenueForm/style.scss
// module id = 1318
// module chunks = 0